/**
 * @file コンポーネント：ボタン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledButton = styled.a`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 6px 22px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1;

    &[data-button-type="accent"] {
        background-color: #061c72;
        color: #ffffff;
    }

    &[data-button-type="cancel"] {
        color: #25292d;
    }

    &[data-button-type="main"] {
        background-color: #2c7cda;
        color: #e4eefa;
    }

    &[data-button-type="mono"] {
        padding: 5px 21px;
        border: 1px solid #25292d;
        background-color: #ffffff;
        color: #25292d;
    }

    &[data-button-type="normal"] {
        background-color: #25292d;
        color: #ffffff;
    }

    &[data-button-type="payment"] {
        background-color: #00b700;
        color: #ffffff;
    }

    &[data-button-type="sub"] {
        padding: 5px 21px;
        border: 1px solid #007dff;
        background-color: #ffffff;
        color: #007dff;
    }

    &[data-button-type="submit"] {
        background-color: #061c72;
        color: #ffffff;
    }

    &.is-disabled {
        background-color: #d7d7d7;
        color: #868686;
        pointer-events: none;
    }

    &.is-dummy-disabled {
        cursor: default;
    }

    &.is-fullheight {
        height: 100%;
    }

    &.is-wide {
        width: 100%;
    }
`;

export const StyledButtonIcon = styled.span`
    margin-right: 4px;
    font-weight: normal;

    &[data-font-weight="bold"] {
        font-weight: bold;
    }
`;

export const StyledButtonText = styled.span``;
